import { useAuth } from '../auth/AuthProvider';
import { useCallback } from 'react';

export function useApi() {
  const { session } = useAuth();

  const apiFetch = useCallback(async <T = unknown>(
    path: string,
    options?: RequestInit,
  ): Promise<T> => {
    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
      ...(options?.headers as Record<string, string>),
    };

    if (session?.accessToken) {
      headers['Authorization'] = `Bearer ${session.accessToken}`;
    }

    const portalUrl = (import.meta as any).env?.VITE_PORTAL_API_URL || '';
    const url = portalUrl ? `${portalUrl}${path}` : path;

    const res = await fetch(url, { ...options, headers });

    if (!res.ok) {
      throw new Error(`API ${res.status}: ${res.statusText}`);
    }

    return res.json();
  }, [session?.accessToken]);

  return { apiFetch, isAuthenticated: !!session };
}
